export const Card = ({ children, title, className = "" }) => (
  <div className={`bg-white rounded-xl border border-slate-200/80 shadow-sm overflow-hidden ${className}`}>
    {title && (
      <div className="border-b border-slate-100 bg-slate-50/50 px-6 py-4">
        <h3 className="text-base font-semibold text-slate-800">{title}</h3>
      </div>
    )}
    <div className="p-6">{children}</div>
  </div>
);